<template>
  <div class="about">
    
    <Article name="about">
      <template v-slot:bottom-title>
        <div class="top-image">
          <img :src="randomImage" alt="About tnyu" >
        </div>
      </template>
    </Article>
  </div>
</template>

<style lang="scss" scoped>
.top-image{
  text-align: center;
  margin-top: -100px;
  img{
    width:100%;
    max-width: 540px;
    margin:0 auto;
  }
}
</style>

<script>

import Article from '../components/Article'

export default {
  components:{Article},
  
  data:()=>({

    topImages:[
      require('@/assets/image/artwork-penrose.svg'),
      require('@/assets/image/artwork-mirror.svg'),
      require('@/assets/image/artwork-spot.svg'),
    ]
  }),

  computed: {
    randomImage: function(){
      return this.topImages[Math.floor(Math.random()*this.topImages.length)]
    }
  },
}
</script>